const defaultIsEqual = <T>(a: T, b: T) => a === b;

export class Queue<T> {
  private items: T[];

  private currentItem: T | undefined;

  constructor(private isEqual = defaultIsEqual) {
    this.items = [];
  }

  // Add an item to the end of the queue or amend it if it already exists
  enqueue(item: T): void {
    const nextItem = this.items[0];

    // if the item is the same as the current item, do nothing
    if (nextItem && this.isEqual(nextItem, item)) {
      return;
    }

    // if the item is the same as the new item, do nothing
    if (this.isEqual(this.currentItem, item)) {
      return;
    }

    // add the new item to the end of the queue
    this.items.push(item);
  }

  // Remove and return the item at the start of the queue
  dequeue(): T | undefined {
    this.currentItem = this.items.shift();
    return this.currentItem;
  }

  ack(): void {
    this.currentItem = undefined;
  }

  // Check if the queue is empty
  isEmpty(): boolean {
    return this.items.length === 0;
  }

  isRunning(): boolean {
    return this.currentItem !== undefined;
  }
}
